export var EContainerAuthPatientLoginVariant = /*#__PURE__*/function (EContainerAuthPatientLoginVariant) {
  EContainerAuthPatientLoginVariant["Login"] = "login";
  EContainerAuthPatientLoginVariant["CheckIn"] = "check-in";
  EContainerAuthPatientLoginVariant["Signup"] = "signup";
  return EContainerAuthPatientLoginVariant;
}({});
export var EContainerAuthPatientLoginStep = /*#__PURE__*/function (EContainerAuthPatientLoginStep) {
  EContainerAuthPatientLoginStep["LoginByDateOfBirth"] = "login-by-dob";
  EContainerAuthPatientLoginStep["LoginByContact"] = "login-by-contact";
  EContainerAuthPatientLoginStep["VerifyCode"] = "verify-code";
  EContainerAuthPatientLoginStep["Signup"] = "signup";
  return EContainerAuthPatientLoginStep;
}({});